import React, { useContext, useEffect, useState } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";
import Orderreporttable from "../sections/Orderreport/Orderreporttable";
import Breadcrumb from "../sections/Orderreport/Breadcrumb";

export const Salesorderreport = () => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");
      const [orderHide, setHideOrder] = useState(true);
      const [mOrderHide, setHideMOrder] = useState(true);
    
      useEffect(() => {
        JSON.parse(authPermission).forEach(function (loca) {
          if (
            loca.access_level.access_level == "ADMIN"
          ) {
            setHideOrder(false);
          }

          if (
            loca.access_level.access_level == "STORE_ADMIN_USER"
          ) {
            setHideOrder(false);
          }
  
          if (
            loca.access_level.access_level == "SUPER_ADMIN"
          ) {
            setHideMOrder(false);
          }

          if (
            loca.access_level.access_level == "STORE_USER"
          ) {
            setHideMOrder(false);
          }
        });
      }, [authPermission]);
      
  return (

    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <div
          hidden={mOrderHide}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 50
          }}
        >
          <iframe
            src="https://lookerstudio.google.com/embed/reporting/c0d3b992-a67a-4b31-9ac4-3a2202b663ea/page/p_19gt0tbffd"
            style={{
              width: '98%',
              height: '1200px',
              border: 'none'
            }}
            title="Embedded Page"
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            allowfullscreen
          />
        </div>
        <div
          hidden={orderHide}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 50
          }}
        >
          <iframe
            src="https://lookerstudio.google.com/embed/reporting/5a3912c0-d41d-46d5-8303-28bbfa6f1707/page/p_ln6e4ldhqd"
            style={{
              width: '98%',
              height: '1200px',
              border: 'none'
            }}
            title="Embedded Page"
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            allowfullscreen
          />
        </div>
      </main>
      <Quickbar />
    </div>
  );
};

   // <>
    //       <div
    //         hidden={mOrderHide}
    //         className={
    //           ctx.darkMode
    //             ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
    //             : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
    //         }
    //       >
    //         <Sidenavigation />
    //         <main className="body-content">
    //           <Topnavigation />
    //           <div className="ms-content-wrapper">
    //             <div className="row">
    //               <div className="col-md-12">
    //                 <Breadcrumb />
    //                 <Orderreporttable />
    //               </div>
    //             </div>
    //           </div>
    //         </main>
    //         <Quickbar />
    //       </div>
          {/* <div
            hidden={orderHide}
            className={
              ctx.darkMode
                ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
                : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
            }
          >
            <Sidenavigation />
            <main className="body-content">
              <Topnavigation />
              <div className="ms-content-wrapper">
                <div className="row">
                  <div className="col-md-12">
                    <Breadcrumb/>
                    <OrderNewtable />
                  </div>
                </div>
              </div>
            </main>
            <Quickbar />
          </div> */}
        // </>
export default Salesorderreport;
